import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ModalService } from '../shared/components/modal/modal.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  constructor(private title: Title, private modalService: ModalService) {}

  ngOnInit(): void {
    this.title.setTitle('کارگزاری آبان | خدمات کارگزاری و سرمایه گذاری');
    // setTimeout(() => {
    //   this.modalService.open('notification');
    // }, 5 * 1000);
  }
}
